<template>

	<div style="overflow-x: hidden;overflow-y: hidden;">
		<navbar></navbar>
		<!-- banner -->
		<vue-particles id="particles-js" color="#fff" :particleOpacity="0.7" :particlesNumber="80" shapeType="circle"
			:particleSize="4" linesColor="#fff" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4"
			:linesDistance="150" :moveSpeed="2" :hoverEffect="false" hoverMode="grab" :clickEffect="false"
			clickMode="push" class="particles-js">
		</vue-particles>
		<div class="row at-row no-gutter" style="min-height:530px; height:100px;">

			<div class="col-md-5"></div>
			<div class="col-md-14">
				<div>
					<p id="pool_title"><span>{{$t('index.pool_title')}}</span></p>
					<p><span id="pool_desc">{{$t('index.pool_desc')}}</span></p>
					<div style="width:100%;margin:220px auto;height:280px;" id="sliderImg" class="row at-row no-gutter">
						<div class="col-md-2">
							<!-- <div class="el-icon-arrow-left option—slider" style="float: left;"></div> -->
						</div>
						<div class="col-md-20">
							<!-- Using the slider component -->
							<slider ref="slider" :options="options" @slide='slide' @tap='onTap' @init='onInit'>
								<!-- slideritem wrapped package with the components you need -->
								<!-- <template slot-scope="fade"> -->

								<slideritem v-for="(item,index) in someList" :pageLength="someList.length"
									:index="index" :key="index" :style="item.style">

									<img :src="item.html" style="border-radius: 10px;" width="60%" height="100%" />

								</slideritem>

								<!-- </template> -->
								<!-- Customizable loading -->
								<div slot="loading">loading...</div>
							</slider>
						</div>
						<div class="col-md-2">
							<!-- <div class="el-icon-arrow-right option—slider"></div> -->
						</div>
					</div>
				</div>

				<div class="col-md-5"></div>
			</div>
		</div>
		<el-dialog title="公告" :visible.sync="shownotice" width="30%" center>
			<span v-html="notice"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="shownotice = false">我知道了</el-button>
			</span>
		</el-dialog>
		<!-- 主要币种详细 -->

		<div class="row at-row no-gutter" id="content">

			<div class="col-md-5"></div>
			<div class="col-md-14">
				<!-- @row-click="rowClick" :row-key="id"  @expand-change="opentable" -->
				<el-tabs v-model="indexActive" style="margin-top: 2rem;" >
					<el-tab-pane :label="$t('index.cpu')" name="cpu">


						<el-table :data="tableData" @row-click="rowClick" :row-key="getid" :expand-row-keys="expands"
							:default-sort="{prop: 'name', order: 'ascending'}"
							style="width: 100%;margin-top: 0.2rem;text-align: center;" id="coin_content">
							<el-table-column type="expand" class="item-content" style="background-color: #ebeef5;">
								<template slot-scope="props">
									<div>

										<el-row :gutter="20" :v-mode="getCoinStatus(props.row.name)">
											<el-col :span="14">
												<div class="coin-charts">
													<div :id=props.row.name
														style="width: 90%;height:380px;margin: auto;margin-top: 20px;">
													</div>
												</div>
											</el-col>
											<el-col :span="10">
												<div class="coin-charts" style="height: 12.5rem;">
													<div style="width: 90%;height: 95%; margin:  auto;">
														<el-row :gutter="15" style="height: 4.5rem;margin-top: 15px;">
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.netdiff')}}</p><br />
																	<span class="coin-charts-desc">{{diff}}</span>
																</div>
															</el-col>
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.algo')}}</p><br />
																	<span class="coin-charts-desc">{{algo}}</span>
																</div>
															</el-col>
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.coinstatus')}}</p><br />
																	<span class="coin-charts-desc">{{coinstat}}</span>
																	<el-popover placement="top-start" width="200"
																		trigger="hover" :content="coinstatus">
																		<i class="el-icon-warning-outline"
																			style="color: #476EF6;"
																			slot="reference"></i>
																	</el-popover>
																</div>
															</el-col>
														</el-row>
														<el-row :gutter="15" style="height: 4.5rem;margin-top: 15px;">
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.fee')}}</p><br />
																	<span class="coin-charts-desc">0% PPLNS</span>
																</div>
															</el-col>
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.paymenttime')}}</p>
																	<br />
																	<span
																		class="coin-charts-desc">{{$t('index.payfre')}}</span>
																</div>
															</el-col>
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.payThreshold')}}</p><br />
																	<span class="coin-charts-desc">0.005XMR</span>
																</div>
															</el-col>
														</el-row>
													</div>
												</div>
												<div class="coin-charts"
													style="height: 11.25rem; margin-top: 1.25rem;padding-left: 1.25rem;padding-right: 1.25rem;">
													<el-tabs v-model="activeName">
				

														<el-tab-pane :label="$t('index.foreignaddress')" name="second">
															<ul v-if="props.row.name === 'ETH'">
																<li>auto.c3pool.org:43333&nbsp;<i
																		class="el-icon-document-copy copyButton"
																		data-clipboard-text="auto.c3pool.org:43333"
																		@click="copyText"></i></li>
															</ul>
															<ul v-else>
																<li><span
																		id="13333">auto.c3pool.org:13333</span>&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:13333"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i>
																</li>
																<li class="15555">auto.c3pool.org:15555&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:15555"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i>
																</li>
																<li class="17777">auto.c3pool.org:17777&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:17777"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
																<li>auto.c3pool.org:23333&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:23333"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
																<li>auto.c3pool.org:80&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:80"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
																<li>auto.c3pool.org:443&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:443"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
															</ul>
														</el-tab-pane>


														<el-tab-pane :label="$t('index.tlsaddrss')" name="thread">
															<ul v-if="props.row.name === 'ETH'">
																<li>auto.c3pool.org:53333&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:53333"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
										
															</ul>
															<ul v-else>
																<li>auto.c3pool.org:33333&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:33333"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
															</ul>
														</el-tab-pane>
													</el-tabs>
												</div>
											</el-col>
										</el-row>
									</div>

									<!--  -->
								</template>
							</el-table-column>


							<el-table-column :label="$t('index.coinname')" prop="name" sortable>
								<template slot-scope="props">

									<span class="font_coin"><img :src="props.row.icon" width="26"
											height="26">&nbsp{{ props.row.name }}</img></span>
								</template>
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.syl')" prop="profit" sortable>
								<template slot-scope="props">
									<el-tooltip class="item" effect="dark" :content="$t('index.syl_desc')"
										placement="bottom-end">
										<span
											style="cursor:pointer;border-bottom:1px #91a1a1 dashed;font-size: 0.725rem;">
											{{props.row.profit}}
										</span>
									</el-tooltip>

								</template>
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.price')" prop="price">
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.award')" prop="award">
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.effort')" prop="effort">
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.poolHash')" prop="poolHash"
								sortable>
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.netHash')" prop="netHash">
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.minercount')" prop="minerCount"
								sortable>
							</el-table-column>
							<el-table-column :label="$t('index.help')" prop="help">
								<template slot-scope="props">
									<span class="font_coin">
										<el-button type="primary" @click="help( props.row.name)" plain>
											{{$t('index.help')}}
										</el-button>
										<!-- <el-link :underline="false" @click="help( props.row.name)">帮助</el-link> -->
									</span>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>


					<el-tab-pane :label="$t('index.gpu')" name="gpi">
						<el-table :data="gpudata" @row-click="rowClick" :row-key="getid" :expand-row-keys="expands"
							:default-sort="{prop: 'name', order: 'ascending'}"
							style="width: 100%;margin-top: 0.2rem;text-align: center;" id="coin_content">
							<el-table-column type="expand" class="item-content" style="background-color: #ebeef5;">
								<template slot-scope="props">
									<div>
						
										<el-row :gutter="20" :v-mode="getCoinStatus(props.row.name)">
											<el-col :span="14">
												<div class="coin-charts">
													<div :id=props.row.name
														style="width: 90%;height:380px;margin: auto;margin-top: 20px;">
													</div>
												</div>
											</el-col>
											<el-col :span="10">
												<div class="coin-charts" style="height: 12.5rem;">
													<div style="width: 90%;height: 95%; margin:  auto;">
														<el-row :gutter="15" style="height: 4.5rem;margin-top: 15px;">
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.netdiff')}}</p><br />
																	<span class="coin-charts-desc">{{diff}}</span>
																</div>
															</el-col>
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.algo')}}</p><br />
																	<span class="coin-charts-desc">{{algo}}</span>
																</div>
															</el-col>
															<el-col :span="8">
						
																<div class="">
																	<p>{{$t('index.support')}}</p>
																	<br />
																	<span
																		class="coin-charts-desc">{{$t('index.payType')}}</span>
																</div>
															</el-col>
														</el-row>
														<el-row :gutter="15" style="height: 4.5rem;margin-top: 15px;">
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.fee')}}</p><br />
																	<span class="coin-charts-desc">1.5% PPS+</span>
																</div>
															</el-col>
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.paymenttime')}}</p>
																	<br />
																	<span
																		class="coin-charts-desc">{{$t('index.payfre2')}}</span>
																</div>
															</el-col>
															<el-col :span="8">
																<div class="">
																	<p>{{$t('index.payThreshold')}}</p><br />
																	<span class="coin-charts-desc">0.01ETH</span>
																</div>
															</el-col>
														</el-row>
													</div>
												</div>
												<div class="coin-charts"
													style="height: 11.25rem; margin-top: 1.25rem;padding-left: 1.25rem;padding-right: 1.25rem;">
													<el-tabs v-model="activeName">
										
						
														<el-tab-pane :label="$t('index.foreignaddress')" name="second">
															<ul v-if="props.row.name === 'ETH'">
																<li>eth.starmap.stream:18888&nbsp;<i
																		class="el-icon-document-copy copyButton"
																		data-clipboard-text="eth.starmap.stream:18888"
																		@click="copyText"></i></li>
															</ul>
															<ul v-else>
																<li><span
																		id="13333">auto.c3pool.org:13333</span>&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:13333"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i>
																</li>
																<li class="15555">auto.c3pool.org:15555&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:15555"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i>
																</li>
																<li class="17777">auto.c3pool.org:17777&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:17777"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
																<li>auto.c3pool.org:23333&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:23333"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
																<li>auto.c3pool.org:80&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:80"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
																<li>auto.c3pool.org:443&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:443"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
															</ul>
														</el-tab-pane>
						
						<!-- 
														<el-tab-pane :label="$t('index.tlsaddrss')" name="thread">
															<ul v-if="props.row.name === 'ETH'">
																<li>auto.c3pool.org:53333&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:53333"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
										
															</ul>
															<ul v-else>
																<li>auto.c3pool.org:33333&nbsp;<i
																		data-clipboard-text="auto.c3pool.org:33333"
																		class="el-icon-document-copy copyButton"
																		@click="copyText"></i></li>
															</ul>
														</el-tab-pane> -->
													</el-tabs>
												</div>
											</el-col>
										</el-row>
									</div>
						
									<!--  -->
								</template>
							</el-table-column>
						
						
							<el-table-column :label="$t('index.coinname')" prop="name" sortable>
								<template slot-scope="props">
						
									<span class="font_coin"><img :src="props.row.icon" width="26"
											height="26">&nbsp{{ props.row.name }}</img></span>
								</template>
							</el-table-column>
					<!-- 		<el-table-column class="coin-desc-other" :label="$t('index.syl')" prop="profit" sortable>
								<template slot-scope="props">
									<el-tooltip class="item" effect="dark" :content="$t('index.syl_desc')"
										placement="bottom-end">
										<span
											style="cursor:pointer;border-bottom:1px #91a1a1 dashed;font-size: 0.725rem;">
											{{props.row.profit}}
										</span>
									</el-tooltip>
						
								</template>
							</el-table-column> -->
							<el-table-column class="coin-desc-other" :label="$t('index.price')" prop="price">
							</el-table-column>
					<!-- 		<el-table-column class="coin-desc-other" :label="$t('index.award')" prop="award">
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.effort')" prop="effort">
							</el-table-column> -->
							<el-table-column class="coin-desc-other" :label="$t('index.poolHash')" prop="poolHash"
								>
								<template slot-scope="props">
									{{ethpoolhash}}
								</template>
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.netHash')" prop="netHash">
							</el-table-column>
							<el-table-column class="coin-desc-other" :label="$t('index.netdiff')" prop="minerCount"
								>
								
								<template slot-scope="props">
									{{ethnetdiff}}
								</template>
							</el-table-column>
							<el-table-column :label="$t('index.help')" prop="help">
								<template slot-scope="props">
									<span class="font_coin">
										<el-button type="primary" @click="help( props.row.name)" plain>
											{{$t('index.help')}}
										</el-button>
										
										<!-- <el-button type="primary" @click="window.open('https://c3pool.com/labs/course')" plain>
											{{$t('index.help')}}
										</el-button> -->
										<!-- <el-link :underline="false" @click="help( props.row.name)">帮助</el-link> -->
									</span>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
					
				</el-tabs>
			</div>
			<div class="col-md-5"></div>
		</div>
		<footerbar></footerbar>


	</div>

</template>

<script>
	import particlesJs from "particles.js";
	import particlesConfig from "./particles.json";
	var UA = require('ua-device');
	import {
		formatDate,
		formatDate2
	} from '../../utils/dataUtil.js'
	import {
		slider,
		slideritem
	} from 'vue-concise-slider'
	import * as echarts from 'echarts';
	import navbar from '../../toolbar/navbar.vue'
	import footerbar from '../../toolbar/footer.vue'
	var axios = require('axios');
	import Clipboard from 'clipboard';
	export default {
		name: "index",
		components: {
			slider,
			slideritem,
			navbar,
			footerbar
		},
		data() {
			return {
				activeName: 'second',
				shownotice: false,
				notice: "",
				lang: localStorage.getItem('locale') || 'zh',
				someList: [{
						html: '/static/1.png#1',
						style: {
							// 'background': '#4abf8a',
							'width': '100%',
							"float": "right"
							// 'margin-right': '2%'
						}
					},
					{
						html: '/static/2.png',
						style: {
							// 'background-image': 'http://nui.c3pool.cn/static/2.png',
							'width': '100%',
							"margin": "auto"

							// 'margin-right': '2%'
						}
					}
				],
				getid(row) {
					return row.id
				},
				xmrChart: null,
				options: {
					effect: 'fade',
					// currentPage: 0,
					// thresholdDistance: 100,
					thresholdTime: 300,
					// deviation: 200,
					// widthScalingRatio: 0.8,
					// heightScalingRatio: 0.8,
					// slidesToScroll: 3,
					//  infinite: 4,
					// loop: true,
					loop: true,
					autoplay: '2000',

				},
				tableData: [],
				// 要展开的行，数值的元素是row的key值
				expands: [],
				poolstat: {},
				networkstat: {},
				minBlockRewards: 0,
				COINS: {},
				L: { //Localization
					perc: '9 %',
					thou: ',',
					dec: '.',
					tme: 'G:i'
				},
				hashconv: {
					TH: 1000000000000,
					GH: 1000000000,
					MH: 1000000,
					KH: 1000,
					H: 1
				},
				option: {
					title: {
						text: ''
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					legend: {
						data: [this.$t('index.netHash'), this.$t('index.chartspriceunit')],

					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},

					xAxis: {
						type: 'category',
						boundaryGap: false,
						axisLabel: {
							interval: 150
						},
						data: []
					},
					yAxis: [{
							type: 'value',
							name: this.$t('index.chartshashunit'),
							// nameLocation: "center",
							// nameGap: 35,
							// nameRotate: 0,
							// nameTextStyle: {
							// 	fontSize: 10,
							// 	// margin-left:10px
							// },
							//默认以千分位显示，不想用的可以在这加一段
							axisLabel: { //调整左侧Y轴刻度， 直接按对应数据显示

								formatter: function(value) {
									return value;
								}
							}

						},
						{
							type: 'value',
							name: this.$t('index.chartspriceunit'),
							// nameLocation: "center",
							// nameGap: 35,
							// nameRotate: 0,
							// nameTextStyle: {
							// 	fontSize: 16,
							// },
							//默认以千分位显示，不想用的可以在这加一段
							axisLabel: { //调整左侧Y轴刻度， 直接按对应数据显示
								// show: true,
								// showMinLabel: true,
								// showMaxLabel: true,
								formatter: function(value) {
									return value;
								}
							}
						}
					],
					series: [

						{
							name: this.$t('index.netHash'),
							type: 'line',

							yAxisIndex: 0,
							data: []
						},
						{
							name: this.$t('index.chartspriceunit'),
							type: 'line',

							yAxisIndex: 1,
							data: []
						}
					]
				},
				chartsconfig: {},
				chartsdata: {},
				coinport: [{
					value: '18081',
					label: 'XMR'
				}, {
					value: '18181',
					label: 'XMC'
				}, {
					value: '19734',
					label: 'SUMO'
				}, {
					value: '12211',
					label: 'RYO'
				}, {
					value: '18981',
					label: 'GRFT'
				}, {
					value: '38081',
					label: 'MSR'
				}, {
					value: '48782',
					label: 'LTHN'
				}, {
					value: '34568',
					label: 'WOW'
				}, {
					value: '19281',
					label: 'XMV'
				}, {
					value: '9231',
					label: 'XEQ'
				}, {
					value: '19950',
					label: 'XWP'
				}, {
					value: '8766',
					label: 'RVN'
				}, {
					value: '8545',
					label: 'ETH'
				}, {
					value: '11181',
					label: 'AEON'
				}, {
					value: '17750',
					label: 'XHV'
				}, {
					value: '20206',
					label: 'DERO'
				}, {
					value: '25182',
					label: 'TUBE'
				}, {
					value: '11812',
					label: 'XLA'
				}, {
					value: '33124',
					label: 'XTNC'
				}, {
					value: '11898',
					label: 'TRTL'
				}, {
					value: '13007',
					label: 'IRD'
				}, {
					value: '19994',
					label: 'ARQ'
				}, {
					value: '16000',
					label: 'CCX'
				}, {
					value: '9053',
					label: 'ERG'
				}],
				diff: 0,
				coinstatus: '',
				coinstat: this.$t('index.coinstat'),
				L: { //Localization
					perc: '9 %',
					thou: ',',
					dec: '.',
					tme: 'G:i'
				},
				hashconv: {
					TH: 1000000000000,
					GH: 1000000000,
					MH: 1000000,
					KH: 1000,
					H: 1
				},
				algo: '',
				indexActive: "cpu",
				gpudata:[],
				ethnetdiff:1,
				ethpoolhash:""

			}


		},

		methods: {
			initethhash(){
				let that = this
				var config = {
				  method: 'get',
				  url: 'https://napi.c3pool.org/getLabsPoolHash',
				  headers: { }
				};
				
				axios(config)
				.then(function (response) {
					that.ethpoolhash=response.data.data.eth
				
				})
				.catch(function (error) {
				  console.log(error);
				});
			},
			initnotice() {
				let that = this
				var config = {
					method: 'get',
					url: 'https://c3pool.com/notice.json',
					headers: {}
				};

				axios(config)
					.then(function(response) {
						if (response.data.code === 0) {
							that.notice = response.data.notice
							that.shownotice = true
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			chartResize() {
				let eleArr = [this.xmrChart];
				for (let i = 0; i < eleArr.length; i++) {
					//此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
					setTimeout(function() {
						eleArr[i].resize();
					}, 200);
				}
			},
			HashConv2(h) {
				h = (h > 0) ? h : 0;
				var u = '';
				for (var k in this.hashconv) {
					if (h >= this.hashconv[k]) {
						h = h / this.hashconv[k];
						u = k + u;
						break;
					}
				}
				if (h === 0) u = 'H/s'
				return {
					'num': this.Rnd(h, 2),
					'unit': u
				};
			},
			HashConvStr2(h, unit) {
				var h = this.HashConv2(h);
				return h.num + ' ' + (unit ? h.unit.replace(/H\//, unit + '/') : h.unit);
			},
			HashConvStr(h, unit) {
				var h = this.HashConv(h);
				return h.num + ' ' + (unit ? h.unit.replace(/H\//, unit + '/') : h.unit);
			},
			HashConv(h) {
				h = (h > 0) ? h : 0;
				var u = '/s';
				for (var k in this.hashconv) {
					if (h >= this.hashconv[k]) {
						h = h / this.hashconv[k];
						u = k + u;
						break;
					}
				}
				if (h === 0) u = 'H/s'
				return {
					'num': this.Rnd(h, 2),
					'unit': u
				};
			},
			Rnd(n, dec, m) {
				if (dec >= 1) {
					var d = Math.pow(10, dec);
					n = Math.round(n * d) / d;
					if (m === 'txt') {
						n = n.toFixed(dec);
						if (this.L.dec !== '.') n = n.replace('.', this.L.dec);
					}
				} else {
					n = Math.round(n);
				}
				return n;
			},
			diif2String(value){
				value=value*1
				if(value<1000){
					return value+"H"
				}else if(value>=1000&&value<1000000000){
					return (value/1000).toFixed(2)+"K"
				}else if(value>=1000000000&&value<1000000000000){
					return (value/1000000000).toFixed(2)+"M"
				}else if(value>=1000000000000&&value<1000000000000000){
					return (value/1000000000000).toFixed(2)+"T"
				}else if(value>=1000000000000000&&value<1000000000000000000){
					return (value/1000000000000000).toFixed(2)+"P"
				}else{
					return value
				}
			},
			getCoinStatus(coin) {
				var port = ''
				for (var i in this.coinport) {
					if (this.coinport[i].label === coin) {
						port = this.coinport[i].value;
						break;
					}
				}
				this.diff = this.HashConvStr(this.networkstat[port].difficulty)

				let stats = this.poolstat.pool_statistics.coinComment[port]
				this.algo = this.poolstat.pool_statistics.portCoinAlgo[port]
				if (stats === "") {
					this.coinstat = this.$t('index.coinstat')
					this.coinstatus = this.$t('index.coinstatus')
				} else {
					this.coinstat = this.$t('index.coinstat2')
					this.coinstatus = stats
				}

			},
			copyText(ele) { //复制文本 需要在文档中添加一个复制用的input  previousSibling/previousElementSibling/ nextElementSibling
				var clipboard = new Clipboard('.copyButton')
				clipboard.on('success', e => {
					this.$notify({
						title: this.$t('index.copysuccess'),
						message: this.$t('index.copysuccess_msg'),
						type: 'success'
					});
					// 释放内存
					clipboard.destroy();
				})
				clipboard.on('error', e => {
					// 不支持复制
					// 释放内存
					clipboard.destroy()
				})


			},
			xmrChart1() {


				console.log(this.lang)
				var that = this
				if (this.lang === 'zh') {


					setTimeout(() => {
						// 动态数据获取
						// var option = ;
						// console.log(document.getElementById('XMR'))
						// var xmrChart = echarts.init(document.getElementById('XMR'))

						if (document.getElementById('XMR') != null) {
							this.option.title.text = "XMR" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XMR']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XMR'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XMR'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XMR'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XMR'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('XMR'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('ETH') != null) {
							this.option.title.text = "ETH" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['ETH']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['ETH'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['ETH'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['ETH'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['ETH'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('ETH'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('IRD') != null) {
							this.option.title.text = "IRD" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['IRD']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['IRD'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['IRD'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['IRD'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['IRD'][item].cny)
							}
							// console.log()
							that.xmrChart = echarts.init(document.getElementById('IRD'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('LTHN') != null) {
							this.option.title.text = "LTHN" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['LTHN']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['LTHN'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['LTHN'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['LTHN'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['LTHN'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('LTHN'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('MSR') != null) {
							this.option.title.text = "MSR" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['MSR']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['MSR'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['MSR'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['MSR'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['MSR'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('MSR'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('RVN') != null) {
							this.option.title.text = "RVN" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['RVN']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['RVN'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['RVN'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['RVN'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['RVN'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('RVN'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('RYO') != null) {
							this.option.title.text = "RYO" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['RYO']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['RYO'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['RYO'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['RYO'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['RYO'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('RYO'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('TRTL') != null) {
							this.option.title.text = "TRTL" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['TRTL']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['TRTL'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['TRTL'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['TRTL'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['TRTL'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('TRTL'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('TUBE') != null) {
							this.option.title.text = "TUBE" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['TUBE']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['TUBE'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['TUBE'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['TUBE'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['TUBE'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('TUBE'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XEQ') != null) {
							this.option.title.text = "XEQ" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XEQ']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XEQ'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XEQ'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XEQ'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XEQ'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('XEQ'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XHV') != null) {
							this.option.title.text = "XHV" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XHV']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XHV'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XHV'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XHV'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XHV'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('XHV'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XLA') != null) {
							this.option.title.text = "XLA" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XLA']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XLA'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XLA'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XLA'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XLA'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('XLA'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XMV') != null) {
							this.option.title.text = "XMV" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XMV']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XMV'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XMV'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XMV'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XMV'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('XMV'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XWP') != null) {
							this.option.title.text = "XWP" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XWP']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XWP'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XWP'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XWP'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XWP'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('XWP'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('ARQ') != null) {
							this.option.title.text = "ARQ" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['ARQ']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['ARQ'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['ARQ'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['ARQ'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['ARQ'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('ARQ'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('CCX') != null) {
							this.option.title.text = "CCX" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []

							for (var item in this.chartsdata['CCX']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['CCX'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['CCX'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['CCX'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['CCX'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('CCX'))
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('DERO') != null) {
							this.option.title.text = "DERO" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['DERO']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['DERO'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['DERO'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['DERO'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['DERO'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('DERO'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('ERG') != null) {
							this.option.title.text = "ERG" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['ERG']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['ERG'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['ERG'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['ERG'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['ERG'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('ERG'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('GRFT') != null) {
							this.option.title.text = "GRFT" + this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['GRFT']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['GRFT'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['GRFT'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['GRFT'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['GRFT'][item].cny)
							}
							that.xmrChart = echarts.init(document.getElementById('GRFT'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						}

					}, 1)
				} else if (this.lang === 'en' || this.lang === 'hk') {
					setTimeout(() => {
						if (document.getElementById('XMR') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XMR']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XMR'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XMR'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XMR'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XMR'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('XMR'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('ETH') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['ETH']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['ETH'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['ETH'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['ETH'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['ETH'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('ETH'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('IRD') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['IRD']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['IRD'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['IRD'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['IRD'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['IRD'][item].doller)
							}
							// console.log()
							that.xmrChart = echarts.init(document.getElementById('IRD'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('LTHN') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['LTHN']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['LTHN'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['LTHN'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['LTHN'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['LTHN'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('LTHN'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('MSR') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['MSR']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['MSR'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['MSR'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['MSR'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['MSR'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('MSR'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('RVN') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['RVN']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['RVN'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['RVN'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['RVN'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['RVN'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('RVN'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('RYO') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['RYO']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['RYO'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['RYO'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['RYO'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['RYO'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('RYO'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('TRTL') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['TRTL']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['TRTL'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['TRTL'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['TRTL'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['TRTL'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('TRTL'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('TUBE') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['TUBE']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['TUBE'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['TUBE'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['TUBE'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['TUBE'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('TUBE'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XEQ') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XEQ']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XEQ'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XEQ'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XEQ'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XEQ'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('XEQ'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XHV') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XHV']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XHV'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XHV'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XHV'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XHV'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('XHV'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XLA') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XLA']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XLA'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XLA'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XLA'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XLA'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('XLA'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XMV') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XMV']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XMV'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XMV'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XMV'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XMV'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('XMV'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('XWP') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['XWP']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['XWP'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['XWP'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['XWP'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['XWP'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('XWP'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('ARQ') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['ARQ']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['ARQ'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['ARQ'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['ARQ'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['ARQ'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('ARQ'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('CCX') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []

							for (var item in this.chartsdata['CCX']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['CCX'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['CCX'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['CCX'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['CCX'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('CCX'))
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('DERO') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['DERO']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['DERO'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['DERO'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['DERO'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['DERO'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('DERO'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('ERG') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['ERG']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['ERG'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['ERG'][item].ts * 1000))
								this.option.series[0].data.unshift(this.chartsdata['ERG'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['ERG'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('ERG'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						} else if (document.getElementById('GRFT') != null) {
							this.option.title.text = this.$t('index.chartstitle')
							this.option.xAxis.data = []
							this.option.series[0].data = []
							this.option.series[1].data = []
							for (var item in this.chartsdata['GRFT']) {
								this.option.yAxis[0].name = this.$t('index.chartshashunit') + '(' + this
									.chartsdata['GRFT'][item].unit + ')'
								this.option.xAxis.data.unshift(formatDate2(this.chartsdata['GRFT'][item].ts *
									1000))
								this.option.series[0].data.unshift(this.chartsdata['GRFT'][item].nethash)
								this.option.series[1].data.unshift(this.chartsdata['GRFT'][item].doller)
							}
							that.xmrChart = echarts.init(document.getElementById('GRFT'))
							// console.log(this.option)
							that.xmrChart.setOption(this.option)
						}
					}, 1)
				}
			},
			HashConv(h) {
				h = (h > 0) ? h : 0;
				var u = '/s';
				for (var k in this.hashconv) {
					if (h >= this.hashconv[k]) {
						h = h / this.hashconv[k];
						u = k + u;
						break;
					}
				}
				if (h === 0) u = 'H/s'
				return {
					'num': this.Rnd(h, 2),
					'unit': u
				};
			},
			HashConvStr(h, unit) {
				var h = this.HashConv(h);
				return h.num + ' ' + (unit ? h.unit.replace(/H\//, unit + '/') : h.unit);
			},
			HashConvStr2(h, unit) {
				var h = this.HashConv(h);
				return h.num + ' ' + 'G/s' //(unit ? h.unit.replace(/H\//, unit + 'G/') : h.unit);
			},
			Rnd(n, dec, m) {
				if (dec >= 1) {
					var d = Math.pow(10, dec);
					n = Math.round(n * d) / d;
					if (m === 'txt') {
						n = n.toFixed(dec);
						if (this.L.dec !== '.') n = n.replace('.', this.L.dec);
					}
				} else {
					n = Math.round(n);
				}
				return n;
			},
			//在<table>里，我们已经设置row的key值设置为每行数据id：row-key="id"
			help: function(e) {
				this.$router.push({
					path: '/help?coin=' + e
				});
				this.$notify({
					title: this.$t('index.tiptitle'),
					message: e + this.$t('index.helpdoc'),
					type: 'success'
				});

			},
			// opentable(row,expandedRows) {
			// 	this.xmrChart1()
			// 	console.log("ccs")
			// 	if (expandedRows.length) {
			// 	            this.expands = []
			// 	            if (row) {
			// 	                this.expands.push(row.id)
			// 	            }
			// 	       } else {
			// 	          this.expands = []
			// 	      }



			// },

			rowClick(row, event, column) {
				/*
				 * 此处新增币种时需按照币种数量对循环进行修改，否则将有表格无法正常关闭
				 */
				// console.log(this.expands)
				// for(var i=1;i<18;i++){
				// 	this.expands.remove(row.id);
				// }
				// console.log("rowClick")
				// Array.prototype.remove = function(val) {
				// 	let index = this.indexOf(val);
				// 	if (index > -1) {
				// 		this.splice(index, 1);
				// 	}
				// 	// console.log(index + 200)
				// };

				// console.log("cilck")
				if (this.expands.indexOf(row.id) < 0) {
					this.expands = []

					this.expands.push(row.id);
					// console.log(row.id)
				} else {
					this.expands = []
				}

				this.xmrChart1()



			},

			// open() {
			// 	this.$prompt('请输入门罗地址', 'C3Pool提示', {
			// 		confirmButtonText: '确定',
			// 		cancelButtonText: '取消',
			// 		inputPattern: /^[4|8]{1}([A-Za-z0-9]{105}|[A-Za-z0-9]{94})$/,
			// 		inputErrorMessage: '门罗地址格式不正确'
			// 	}).then(({
			// 		value
			// 	}) => {
			// 		this.$message({
			// 			type: 'success',
			// 			message: '你的钱包是: ' + value
			// 		});
			// 	}).catch(() => {
			// 		this.$message({
			// 			type: 'info',
			// 			message: '取消输入'
			// 		});
			// 	});
			// },
			// slideNext () {
			//     this.$re
			// 	fs.slider.$emit('slideNext')

			//   },
			//   slide () {
			//       this.$refs.slider.$emit('slidePre')
			//     }
			slide(data) {
				// console.log(data)
			},
			onTap(data) {
				// console.log(data)
			},
			onInit(data) {
				// console.log(data)
			},
			goPage(url) {
				this.$router.push({
					path: url
				})
			},
			difficultyToHashRate(hashrate) {
				return Math.floor(hashrate / 120);
			},
			calc(di) {
				return (1000 / this.difficultyToHashRate(this.networkstat.difficulty) * (24 * 60 * 60) / 120 * this
					.poolstat.pool_statistics.minBlockRewards[18081] * di)
			},
			pcInfo() {
				var deviceType = navigator.userAgent; //获取userAgent信息
				var output = new UA(deviceType);
				let osname = output.os.name;
				if ('Android' === osname || 'iOS' === osname) {
					if (this.lang === 'zh') {
						window.location.href = "/oldui/cn"
					} else if (this.lang === 'en') {
						window.location.href = "/oldui/en"
					} else {
						window.location.href = "/oldui/cn"
					}


				}

				// console.log(deviceType);
				// console.log(output);
			},
		},
		created() {
			this.COINS = {
				18081: {
					name: "XMR",
					divisor: 1000000000000,
					url: "https://xmrchain.net",
					time: 120,
				},
				18181: {
					name: "XMC",
					divisor: 1000000000000,
					url: "http://explorer.monero-classic.org",
					time: 120,
				},
				19734: {
					name: "SUMO",
					divisor: 1000000000,
					url: "https://explorer.sumokoin.com",
					time: 240,
				},
				12211: {
					name: "RYO",
					divisor: 1000000000,
					url: "https://explorer.ryo-currency.com",
					time: 240,
				},
				18981: {
					name: "GRFT",
					divisor: 10000000000,
					url: "https://blockexplorer.graft.network",
					time: 120,
				},
				38081: {
					name: "MSR",
					divisor: 1000000000000,
					url: "https://explorer.getmasari.org",
					time: 60,
				},
				48782: {
					name: "LTHN",
					divisor: 100000000,
					url: "https://lethean.io/explorer",
					time: 120,
				},
				34568: {
					name: "WOW",
					divisor: 100000000000,
					url: "http://explore.wownero.com",
					time: 300,
				},
				19281: {
					name: "XMV",
					divisor: 100000000000,
					url: "https://explorer.monerov.online",
					time: 60,
					unit: "G",
					factor: 16,
				},
				9231: {
					name: "XEQ",
					divisor: 10000,
					url: "https://explorer.equilibria.network",
					time: 120,
				},
				19950: {
					name: "XWP",
					divisor: 1000000000000,
					url: "https://explorer.xwp.one",
					time: 15,
					unit: "G",
					factor: 32,
				},
				8766: {
					name: "RVN",
					divisor: 100000000,
					url: "https://ravencoin.network",
					time: 60,
					unit: "H",
					factor: 0xFFFFFFFFFFFFFFFF / 0xFF000000,
				},
				8545: {
					name: "ETH",
					divisor: 1000000000000000000,
					url: "https://etherscan.io/",
					time: 13,
					unit: "H",
					factor: 1,
				},
				11181: {
					name: "AEON",
					divisor: 1000000000000,
					url: "https://aeonblockexplorer.com",
					time: 240,
				},
				17750: {
					name: "XHV",
					divisor: 1000000000000,
					url: "https://explorer.havenprotocol.org",
					time: 120,
				},
				20206: {
					name: "DERO",
					divisor: 1000000000000,
					url: "https://explorer.dero.io",
					time: 27,
				},
				25182: {
					name: "TUBE",
					divisor: 1000000000,
					url: "https://explorer.bittube.cash",
					time: 15,
					unit: "G",
					factor: 40,
				},
				11812: {
					name: "XLA",
					divisor: 100,
					url: "https://explorer.scalaproject.io",
					time: 120,
				},
				33124: {
					name: "XTNC",
					divisor: 1000000000,
					url: "https://explorer.xtendcash.com",
					time: 120,
					unit: "G",
					factor: 32,
				},
				11898: {
					name: "TRTL",
					divisor: 100,
					url: "https://explorer.turtlecoin.lol",
					time: 30,
				},
				13007: {
					name: "IRD",
					divisor: 100000000,
					url: "https://explorer.ird.cash",
					time: 175,
				},
				19994: {
					name: "ARQ",
					divisor: 1000000000,
					url: "https://explorer.arqma.com",
					time: 120,
				},
				16000: {
					name: "CCX",
					divisor: 1000000,
					url: "https://explorer.conceal.network",
					time: 120,
				},
				9053: {
					name: "ERG",
					divisor: 1000000000,
					url: "https://explorer.ergoplatform.com/en",
					time: 120,
					unit: "H",
					factor: 1,
				}
			}
			this.chartsconfig = {
				method: 'get',
				url: 'https://napi.c3pool.org/database',
				headers: {}
			};
		},

		async mounted() {
			this.initnotice()
			this.pcInfo()
			this.initethhash()

			// if(osinfo.os==='iOS'){
			// 	window.location.href="/oldui/cn"
			// }else if(osinfo.os==='AndroidOS'){
			// 	window.location.href="/oldui/cn"
			// }
			let that = this
			var poolstatconfig = {
				method: 'get',
				url: 'https://api.c3pool.org/pool/stats',
				headers: {}
			};
			var initconfig = {
				method: 'get',
				url: 'https://napi.c3pool.org/coinsInit',
				headers: {}
			};
			await axios(poolstatconfig)
				.then(function(response) {
					that.poolstat = response.data
					// console.log(JSON.stringify(response.data));
				})
				.catch(function(error) {
					// console.log(error);
				});

			var networkstatconfig = {
				method: 'get',
				url: 'https://api.c3pool.org/network/stats',
				headers: {}
			};

			await axios(networkstatconfig)
				.then(function(response) {
					that.networkstat = response.data
					that.ethnetdiff=that.diif2String(response.data[8545].difficulty)
					// console.log(JSON.stringify(response.data));
				})
				.catch(function(error) {
					// console.log(error);
				});
			await axios(initconfig)
				.then(function(response) {

					for (var item = 0; item < 19; item++) { //var item in response.data.data
						try {
							var port = ''
							var effortValue = ''
							// console.log(that.coinport.length)
							for (var i in that.coinport) {
								// console.log(response.data.data[item].name)
								if (that.coinport[i].label === response.data.data[item].name) {
									port = that.coinport[i].value;
									// console.log(that.coinport[i].label)
									break;
								}
							}

							//关停币种下架
							if (response.data.data[item].name === "ERG" || response.data.data[item].name ===
								"RYO") {
								continue
							}


							var xmrprofit = ''
							var price = ''
							if (that.lang === 'zh') {
								price = '￥' + response.data.data[item].cny.toFixed(2)
								xmrprofit = "￥" + that.calc(response.data.data[item].cny).toFixed(4) + " / KH"
							} else if (that.lang === 'en' ||that.lang === 'hk') {
								price = '$' + response.data.data[item].doller.toFixed(2)
								xmrprofit = "$" + that.calc(response.data.data[item].doller).toFixed(4) + " / KH"
							}
							// console.log(port)

							effortValue = ((that.poolstat.pool_statistics.currentEfforts[port] / that.networkstat[
									port]
								.difficulty) * 100).toFixed(0)
							if ("XMR" === response.data.data[item].name) {


								var tmp = {
									"id": response.data.data[item].id,
									"netHash": response.data.data[item].netHash,
									"award": response.data.data[item].award,
									"icon": response.data.data[item].icon,
									"name": response.data.data[item].name,
									"minerCount": response.data.data[item].minerCount,
									"price": price,
									"profit": xmrprofit,
									"poolHash": that.HashConvStr(response.data.data[item].poolHash),
									"effort": effortValue + "%"
								}
								that.tableData.push(tmp)

							} else {
								var poolhashrate = ''
								let name = response.data.data[item].name
								if ("XWP" === name || "XMV" === name || "TUBE" === name) {
									poolhashrate = that.HashConvStr2(response.data.data[item].poolHash)
								} else {
									poolhashrate = that.HashConvStr(response.data.data[item].poolHash)
								}
								var tmp = {
									"id": response.data.data[item].id,
									"netHash": response.data.data[item].netHash,
									"award": response.data.data[item].award,
									"icon": response.data.data[item].icon,
									"name": response.data.data[item].name,
									"minerCount": response.data.data[item].minerCount,
									"profit": response.data.data[item].profit,
									"price": price,
									"poolHash": poolhashrate,
									"effort": effortValue + "%"
								}
								if("ETH"===response.data.data[item].name){
									
									that.gpudata.push(tmp)
								}else{
									that.tableData.push(tmp)
								}
								
							}


						} catch (error) {
							continue
						}
					}


					// console.log(JSON.stringify(response.data));
				})
				.catch(function(error) {
					console.log(error);
				});
			await axios(this.chartsconfig)
				.then(function(response) {
					that.chartsdata = response.data.data
					// console.log(JSON.stringify(response.data));
				})
				.catch(function(error) {
					// console.log(error);
				});


			particlesJS("particles-js", particlesConfig);
			window.addEventListener("resize", this.chartResize);
		},
	};
</script>

<style scoped>
	@import "../../static/styleofIndex.css";
	/* @media screen and (max-width: 400px) {
    .el-message-box{
      width: 300px !important;
    }
	.el-dialog__wrapper .el-dialog {
	      width: 300px !important;
	      .el-dialog__body{
	        padding: 10px 20px!important;
	        .el-form-item__label{
	          width: 68px!important;
	        }
	        .el-select,.el-input{
	          width: 180px!important;
	        }
	      }
	    }
		.el-message-box{
		      width: 300px !important;
		    }
		
  } */

	.coin-charts-desc {
		margin-top: 15px;
		color: #476ef6;
		font-size: 18px;
		font-weight: 500;
		text-align: left;
	}


	#particles-js {
		width: 100%;
		height: 530px;
		position: absolute;
	}

	.contact-us {}

	#pool_title {
		/* margin-top: 6%; */
		top: 8.375rem;
		position: absolute;
		font-size: 3rem;
		font-family: "黑体";
		color: white;
	}

	#pool_desc {
		position: absolute;
		top: 14.375rem;
		font-size: 1.3rem;
		font-family: "黑体";
		color: gainsboro;
	}

	.coin_content_title {
		background-color: #F8FAFF;
	}

	#content {
		margin-bottom: 0px;
		background-color: #F8FAFF;
		padding-bottom: 30px;
		margin-top: -20px;
	}

	.coin_content_content {
		width: 100%;
		height: 100%;

	}

	#coin_content {
		border-radius: 0.5rem;
		box-shadow: 0px 0px 5px skyblue;

	}

	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.font_coin {
		font-size: 18px;
		display: flex;
		line-height: 1.625rem;
		/* color: red; */
		vertical-align: middle;
	}

	.slider-active img {
		border-radius: 10px;
	}

	.coin-charts {
		border-radius: 0.3125rem;
		border: 1px solid #dee2e6 !important;
	}

	.option—slider {
		background-color: #000000;
		width: 48px;
		height: 48px;
		border-radius: 50%;
		float: right;
		color: white;
		font-size: 36px;
		line-height: 48px;
		vertical-align: middle;
		text-align: center;
		opacity: 0.5;
		margin-top: 120px;
		cursor: pointer;
	}

	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 4px;
	}

	#footer {
		background-color: #2C405A;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}

	.el-table__expanded-cell {
		background-color: #ebeef5
	}

	template {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.copyButton:hover {
		color: deepskyblue;
		cursor: pointer;
	}
</style>
